import { Button } from '@creditornot/cb-button';
import { Filter } from '@creditornot/cb-icons';
import { Popover } from '@creditornot/cb-popover';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type FilterMenuProps = {
  children: React.ReactNode;
  appliedFiltersCount: number;
};

const StyledPopover = styled(Popover).attrs({
  placement: 'bottom-start',
  renderArrow: false,
})`
  display: flex;
  align-items: center;
`;

export const FilterMenu = ({ children, appliedFiltersCount }: FilterMenuProps) => {
  const [showFilterMenu, setShowFilterMenu] = useState(false);

  return (
    <div onClick={e => e.stopPropagation()}>
      <StyledPopover
        contentZIndex={3}
        content={children}
        onClickOutside={() => setShowFilterMenu(false)}
        show={showFilterMenu}
      >
        <Button
          variant="lightBlue"
          icon={<Filter />}
          size="small"
          tabIndex={-1}
          onClick={() => {
            setShowFilterMenu(prevState => !prevState);
          }}
        >
          <FormattedMessage id="shared-menu.editor.filter-menu.filter-button-label" />{' '}
          {appliedFiltersCount > 0 && `(${appliedFiltersCount})`}
        </Button>
      </StyledPopover>
    </div>
  );
};
